// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"c292f9b3","682":"0035f1b9","959":"29288ed8"}[chunkId] + ".chunk.css";
};